<template>
    <div class="DocumentsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-lg-3 col-xl-2">
                    <div class="paper olive-green">
                        <b-nav pills vertical class="side-menu">
                            <b-nav-item v-on:click="ChangePaneShown('Drafts')" v-bind:class="{ active: PanesShown == 'Drafts' }"><font-awesome-icon :icon="['fa', 'edit']" /> Drafts</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('Signatures')" v-bind:class="{ active: PanesShown == 'Signatures' }"><font-awesome-icon :icon="['fa', 'signature']" /> Signatures <b-badge variant="light">{{ DocumentsRequiringMySignatureComp }}</b-badge></b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('Explorer')" v-bind:class="{ active: PanesShown == 'Explorer' }"><font-awesome-icon :icon="['fa', 'search']" /> Explorer</b-nav-item>
                        </b-nav>
                    </div>
                </div>
                <div class="col-lg-9 col-xl-10">
                    <div class="paper">
                        <div class="tab-content col-12">
                            <div v-show="PanesShown == 'Audit'">
                                <EmployeeAudit />
                            </div>
                            <div v-show="PanesShown == 'Drafts'">
                                <UserDrafts />
                            </div>
                            <div v-show="PanesShown == 'Signatures'">
                                <SignaturesPane />
                            </div>
                            <div v-show="PanesShown == 'Explorer'">
                                <DocumentExplorer />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    import { faSignature } from '@fortawesome/free-solid-svg-icons';
    library.add(faSignature);
    import { faSearch } from '@fortawesome/free-solid-svg-icons';
    library.add(faSearch);
    //import components
    import UserDrafts from "./UserDrafts.vue";
    import SignaturesPane from "./SignaturesPane.vue";
    import DocumentExplorer from "./DocumentExplorer.vue";

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        created() {
            let vm = this;
            EventBus.$on('documents-requiring-my-signature-updated', docCount => {
                vm.DocumentsRequiringMySignature = docCount;
            });
        },
        beforeDestroy() {
            EventBus.$off('documents-requiring-my-signature-updated');
        },
        props: [],
        data: function () {
            return {
                PanesShown: "Drafts",
                DocumentsRequiringMySignature: 0
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                //loop through Panes shown and flip true/false values
                this.PanesShown = paneName;
            },
        },
        computed: {
            DocumentsRequiringMySignatureComp: function () {
                if (this.DocumentsRequiringMySignature != 0) {
                    return this.DocumentsRequiringMySignature
                } else {
                    return "";
                }
            }
        },
        components: {
            UserDrafts,
            SignaturesPane,
            DocumentExplorer
        }
    }
</script>

<style scoped>
</style>